export const bpStepOut = <svg version="1.0" id="Layer_1" x="0px" y="0px"
  viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
  <circle cx="265.2" cy="399.2" r="64.1" />
  <path d="M375,172.5c-6.2,0-12.4-2.1-17.5-6.3L265,89.9l-92.5,76.3c-11.7,9.7-29.1,8-38.7-3.7c-9.7-11.7-8-29,3.7-38.7L265,18.7
	l127.5,105.1c11.7,9.7,13.4,27,3.7,38.7C390.8,169.1,382.9,172.5,375,172.5z"/>
  <path d="M265,300.4c-15.2,0-27.5-12.3-27.5-27.5V54.3c0-15.2,12.3-27.5,27.5-27.5c15.2,0,27.5,12.3,27.5,27.5v218.6
	C292.5,288.1,280.2,300.4,265,300.4z"/>
</svg>
